import { getMaxSessionDurationSeconds } from './get-max-session-duration-seconds';

export function getMaxSessionDurationMinutes() {
    return getMaxSessionDurationSeconds() / 60;
}
